// Constants for About formulas

export const RELEASE_VERSION = process.env.REACT_APP_RELEASE_VERSION || 'v253';

// Source sets definitions
export const CURATED_SOURCES_GDA = [
  'CLINGEN',
  ...(RELEASE_VERSION === 'v254' ? ['CLINPGX'] : []),
  'CLINVAR',
  'GENCC',
  'MGD',
  'HUMAN',
  'RGD',
  'ORPHANET',
  'PSYGENET',
  'UNIPROT',
];

export const CURATED_SOURCES_VDA = [
  'CLINGEN',
  ...(RELEASE_VERSION === 'v254' ? ['CLINPGX'] : []),
  'CLINVAR',
  'GWASCAT',
  'PHEWASCAT',
  'UNIPROT',
];

export const CLINICAL_TRIALS_SOURCES = ['CLINICALTRIALS'];

export const INFERRED_SOURCES = [
  'FINNGEN',
  'GWASCAT',
  'HPO',
  'PHEWASCAT',
  'UKBIOBANK',
];

export const MODELS_SOURCES = [
  'MGD MOUSE',
  'RGD RAT',
  'TEXTMINING MODELS',
];

export const LITERATURE_SOURCES = [
  'TEXTMINING HUMAN',
  'TEXTMINING MODELS',
];

export const LITERATURE_SOURCES_VDA = ['TEXTMINING HUMAN'];

export const BIOBANK_SOURCES = ['FINNGEN', 'UKBIOBANK'];

// Common MathML namespace
export const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';